import { DropdownButton } from '@rcg/ui-components';
import PropTypes from 'prop-types';

function FilterDropdown({ className, label, openFilter, dataTestId }) {
	const isSelected = className?.split(' ').includes('selected');

	return (
		<DropdownButton data-testid={dataTestId} className={className} selected={isSelected} onClick={openFilter}>
			{label}
		</DropdownButton>
	);
}

FilterDropdown.propTypes = {
	className: PropTypes.string,
	label: PropTypes.string.isRequired,
	openFilter: PropTypes.func.isRequired,
	dataTestId: PropTypes.string,
};

export default FilterDropdown;
